import { SidebarProvider } from "@/shared/ui/sidebar";
import ClientSidebar from "./ClientSidebar";
import { Outlet } from "react-router-dom";
import { ClientDataProvider } from "@/features/projects/contexts/ClientDataContext";
import { useClientId } from "@/shared/hooks/useClientId";

export function ClientLayoutWithSidebar() {
  const { clientId, loading } = useClientId();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!clientId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground">No client found for this account.</div>
      </div>
    );
  }

  return (
    <SidebarProvider defaultOpen={false}>
      <div className="min-h-screen flex w-full bg-background">
        <ClientSidebar />
        
        {/* Main content area */}
        <main className="flex-1 overflow-auto">
          <ClientDataProvider clientId={clientId}>
            <Outlet />
          </ClientDataProvider>
        </main>
      </div>
    </SidebarProvider>
  );
}

